var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('MenuAdmin'),(_vm.loading)?_c('FullScreenLoader'):_vm._e(),(!_vm.loading)?_c('div',[(_vm.active === 3)?_c('LiveShop'):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }